// Payment-method options for reimbursements. Kept in this dependency-free module
// (no API enum imports) so both the forms and unit tests can import it safely.
export const transactionMethodSelectOptions = [
  {
    value: 'CREDIT_CARD',
    label: 'reimbursementPage.submitForm.transactionMethodOptions.creditCard',
  },
  {
    value: 'DEBIT_CARD',
    label: 'reimbursementPage.submitForm.transactionMethodOptions.debitCard',
  },
  {
    value: 'CASH',
    label: 'reimbursementPage.submitForm.transactionMethodOptions.cash',
  },
  {
    value: 'CHECK',
    label: 'reimbursementPage.submitForm.transactionMethodOptions.check',
  },
  {
    value: 'NA',
    label: 'reimbursementPage.submitForm.transactionMethodOptions.na',
  },
];

export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

// Receipts store only the S3 path; derive the display name from its basename.
export const receiptFileName = (path: string | null | undefined): string => {
  if (!path) return '';
  const base = path.split('/').pop() || path;
  try {
    return decodeURIComponent(base);
  } catch {
    return base;
  }
};

// Maps a stored reimbursement transactionType (payment method) to its i18n label key.
export const paymentMethodLabel = (value: string | null | undefined): string => {
  const option = transactionMethodSelectOptions.find((o) => o.value === value);
  return option?.label ?? '';
};
